import AgreeItem from './AgreeItem';
import Checkbox from './Checkbox';
import CheckboxItem from './CheckboxItem';
Checkbox.CheckboxItem = CheckboxItem;
Checkbox.AgreeItem = AgreeItem;
export default Checkbox;
